<div class="tile mat-elevation-z2">
  <div *ngIf="tileImageUrl" class="tile-image" [style]="'background-image: url(' + tileImageUrl + ')'"></div>
  <div class="content mat-headline-5 flex flex-col justify-center items-center">
      <ng-content></ng-content>
  </div>
</div>
